module.exports = __webpack_public_path__ + "img/no_data_en.d56e435a.png";